import React from 'react';

import { RightSidebar } from '@atlaskit/page-layout';

import { useCurrentPanel } from '@atlassian/preview-panels-api';
import { Panel } from '@atlassian/navigation-system/layout/panel';

import { fg } from '@confluence/feature-gating';
import { useIsNav4Enabled } from '@confluence/nav4-enabled';

function NavWrapper({ children }: { children: React.ReactElement }) {
	const isNav4Enabled = useIsNav4Enabled();
	if (isNav4Enabled) {
		return <Panel>{children}</Panel>;
	} else {
		return <RightSidebar>{children}</RightSidebar>;
	}
}

export function PreviewPanelContainer() {
	const [{ content: PanelContent }] = useCurrentPanel();

	if (!fg('confluence_preview_panels')) {
		return null;
	}

	if (!PanelContent) {
		return null;
	}

	return (
		<NavWrapper>
			<PanelContent />
		</NavWrapper>
	);
}
